import { createSelector } from 'reselect'

import { IFormState } from '../models'

export const createIsValidSelector = <T = unknown>(formKey: string) =>
  createSelector(
    (state: { form: IFormState<T> }) => state.form,
    (form) => form[formKey]?.isValid
  )
